import { createFileRoute } from '@tanstack/react-router';
import { VoucherSetupPage } from '@/features/marketing';

/** New campaign › A voucher: the voucher setup screen, creating the campaign on its first save. */
export const Route = createFileRoute('/_auth/$orgId/marketing/campaigns_/new_/voucher')({
  component: NewVoucherRoute,
});

function NewVoucherRoute() {
  const { orgId } = Route.useParams();
  return <VoucherSetupPage orgId={orgId} campaignId={null} />;
}
